import { UrlConstants } from "../url.constants";
export class ApiTrainingConstants {
    static URL = UrlConstants.API_V2 + "TrainingModule";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetApplicantAndApplicantAgent";
    static FUNCTION_GET_MY_AFLA_PORTAL_DEMOLITION_APPLICATIONS = "GetAflaPortalTrainingModuleApplications";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalTrainingModuleApplication";
}
